import { statuses, createDateObject } from '@/core';
import { order } from '@/dataStructures';
import { orderInitialValidationState } from '@/modules/newOrder/validation/order';

function initialState() {
	return {
		order: {
			...order(),
			etd: createDateObject({ hasTime: false }),
			eta: createDateObject({ hasTime: false }),
			status: statuses.order.draft,
			economicalStatus: statuses.economical.notSettled
		},
		orderClone: { subOrders: {} },
		orderShadowCopy: { subOrders: {} },
		subOrders: [  ],
		dirty: false,
		errors: {
			invalidFromAddress: false,
			invalidToAddress: false,

			order: orderInitialValidationState(),

			subOrders: {}, // keys are subOrder's ids, values are the validation state
		},
		trips: [],
		selectedSubOrder: undefined,
		selectedSubOrderShadowCopy: undefined,
		selectedSubOrderTrip: undefined,
		isLoadingTrip: false,
		mainOrderTabIndex: -1,
		currentOrderTabIndex: -1,
		socket: undefined,
		changelog: [],
		ediLog: [],
		orderTypes: [],
		ediName: '',
		deviationBindings: [],
	};
}

export default initialState;
